import { Grid } from '@mui/material'
import FormControlRadio, { radioButtonChoiceOptions } from 'components/FormControlRadio'
import FormInput from 'components/FormInput'
import { FormInputSelect, ItemOption } from 'components/FormInputSelect'
import React, { useCallback, useEffect, useState } from 'react'
import { Control, UseFormSetValue, UseFormWatch } from 'react-hook-form'
import genericService from 'services/generic.service'
import { HearingIdentificationType } from 'types/hearing-identification.type'
import { useHearingIdentificationBlockFieldsContext } from '../../../../../../contexts/hearing-identification-block-fields.context'

type ResponsibleWorkingGroupProps = {
  control: Control<HearingIdentificationType>
  watch: UseFormWatch<HearingIdentificationType>
  setValue: UseFormSetValue<HearingIdentificationType>
}

export const ResponsibleWorkingGroup: React.FC<ResponsibleWorkingGroupProps> = ({
  control,
  watch,
  setValue,
}) => {
  const { isBlockedFields } = useHearingIdentificationBlockFieldsContext()

  const [salaryAmountOptions, setSalaryAmountOptions] = useState<ItemOption[]>([])

  const isResponsibleWorking = watch('identificacaoAdolescente.responsavelTrabalha')

  const fillSalaryAmountOptions = useCallback(async (): Promise<void> => {
    try {
      const res = await genericService.get('/faixa-renda')
      setSalaryAmountOptions(res.data)
    } catch (error) {
      console.error('Salary ammount Request: ', error)
    }
  }, [setSalaryAmountOptions])

  useEffect(() => {
    fillSalaryAmountOptions()
  }, [fillSalaryAmountOptions])

  return (
    <>
      <Grid item lg={3} xs={12}>
        <FormControlRadio
          control={control}
          name='identificacaoAdolescente.responsavelTrabalha'
          label='Responsáveis trabalham?'
          options={radioButtonChoiceOptions}
          disabled={isBlockedFields}
        />
      </Grid>
      {isResponsibleWorking === 'S' && (
        <Grid item xs>
          <FormInput
            control={control}
            name='identificacaoAdolescente.descricaoAtividadeResponsavel'
            label='Atividade dos responsáveis'
            placeholder='Informe a atividade do responsável'
            maxLength={1400}
            required={isResponsibleWorking === 'S'}
          />
        </Grid>
      )}
      <Grid item lg={3} xs={12}>
        <FormInputSelect
          control={control}
          name='identificacaoAdolescente.idRendaFamiliar'
          label='Renda familiar'
          options={salaryAmountOptions}
          disabled={isBlockedFields}
          required={isResponsibleWorking === 'S'}
        />
      </Grid>
    </>
  )
}
